/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host > div {
  width: 100%;
  height: 100%;
}
:host #ws {
  color: transparent;
  font-size: 0;
}
:host .discovery-dashboard-main {
  height: calc(100% - 20px);
  text-align: center;
  color: var(--warp-view-font-color, #404040);
  background: var(--warp-view-dashboard-background, rgba(255, 255, 255, 0));
  background-size: cover;
  padding: 10px;
  width: calc(100% - 20px);
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper {
  display: grid;
  grid-gap: var(--warp-view-dashboard-gap, 10px);
  padding-bottom: 20px;
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile {
  width: 100%;
  border: var(--warp-view-tile-border, 0.1rem solid rgba(0, 0, 0, 0.075)) !important;
  box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08)) !important;
  border-radius: var(--warp-view-tile-border-radius, 0);
  overflow: visible;
  background: var(--warp-view-tile-background, rgba(255, 255, 255, 0));
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard, :host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard-flex, :host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard-scada {
  overflow-y: auto;
  overflow-x: visible;
  margin-bottom: 20px;
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard.auto-height, :host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard-flex.auto-height, :host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.dashboard-scada.auto-height {
  height: auto !important;
  overflow: visible;
  margin-bottom: 20px;
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.annotation, :host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.plot {
  height: 100% !important;
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile.hidden {
  opacity: 0;
  visibility: hidden;
}
:host .discovery-dashboard-main .discovery-dashboard-wrapper .discovery-dashboard-tile > div {
  width: 100%;
  height: 100%;
  margin-bottom: -20px;
}
:host .discovery-flex-main {
  height: 100%;
  text-align: center;
  color: var(--warp-view-font-color, #404040);
  background: var(--warp-view-dashboard-background, rgba(255, 255, 255, 0));
  background-size: cover;
  padding: 10px;
  width: calc(100% - 20px);
}
:host .discovery-flex-main .discovery-flex-wrapper {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 200px;
  min-height: 500px;
  justify-content: start;
  width: 100%;
}
:host .discovery-flex-main .discovery-dashboard-tile {
  flex-grow: 1;
  width: 100%;
  overflow: visible;
  padding: var(--warp-view-dashboard-gap, 10px);
}
:host .discovery-flex-main .discovery-dashboard-tile.dashboard, :host .discovery-flex-main .discovery-dashboard-tile.dashboard-flex, :host .discovery-flex-main .discovery-dashboard-tile.dashboard-scada {
  height: auto !important;
  margin-bottom: 20px;
}
:host .discovery-flex-main .discovery-dashboard-tile.dashboard.auto-height, :host .discovery-flex-main .discovery-dashboard-tile.dashboard-flex.auto-height, :host .discovery-flex-main .discovery-dashboard-tile.dashboard-scada.auto-height {
  height: auto !important;
  overflow: hidden;
  margin-bottom: 20px;
}
:host .discovery-flex-main .discovery-dashboard-tile > div {
  width: 100%;
  height: 100%;
  border-radius: var(--warp-view-tile-border-radius, 0);
  border: var(--warp-view-tile-border, 0.1rem solid rgba(0, 0, 0, 0.075)) !important;
  box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08)) !important;
}
:host .discovery-flex-main .discovery-dashboard-tile.hidden {
  visibility: collapse;
  height: 0 !important;
  margin: 0;
  padding: 0;
}
@media (max-width: 800px) {
  :host .discovery-flex-main .discovery-dashboard-tile {
    max-width: calc(50% - 25px) !important;
  }
}
@media (max-width: 600px) {
  :host .discovery-flex-main .discovery-dashboard-tile {
    max-width: 100% !important;
  }
}
:host .discovery-scada-main {
  padding: 10px;
  width: calc(100% - 20px);
  height: auto;
  text-align: center;
  color: var(--warp-view-font-color, #404040);
  background: var(--warp-view-dashboard-background, rgba(255, 255, 255, 0));
  background-size: cover;
}
:host .discovery-scada-main .discovery-scada-wrapper {
  position: relative;
  height: 100%;
  padding-bottom: 20px;
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: var(--warp-view-tile-border, 0.1rem solid rgba(0, 0, 0, 0.075));
  box-shadow: var(--warp-view-tile-shadow, 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08));
  border-radius: var(--warp-view-tile-border-radius, 0);
  overflow: visible;
  background: var(--warp-view-tile-background);
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard, :host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard-flex, :host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard-scada {
  overflow: auto;
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard.auto-height, :host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard-flex.auto-height, :host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.dashboard-scada.auto-height {
  height: auto !important;
  overflow: hidden;
  margin-bottom: 20px;
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.annotations, :host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.plot {
  overflow-y: auto;
  overflow-x: hidden;
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile.hidden {
  opacity: 0;
}
:host .discovery-scada-main .discovery-scada-wrapper .discovery-scada-tile > div {
  width: 100%;
  height: 100%;
  margin-bottom: -20px;
}
@media print {
  :host .discovery-dashboard-tile {
    break-inside: avoid;
  }
}